module.exports = __webpack_public_path__ + "img/icon-gywm.c2210c9d.png";